/* =============================================================
   VALORATIME — Cross-sell real en el drawer del carrito.
   Usa el endpoint público de recomendaciones de Shopify
   (/recommendations/products.json), basado en el primer producto
   real que haya en el carrito. Si Shopify no devuelve nada (catálogo
   muy chico, sin señales suficientes) el bloque completo se oculta
   en vez de mostrar algo vacío o inventado.
   ============================================================= */
(function () {
  if (window.__vtCartCrosssellInit) return;
  window.__vtCartCrosssellInit = true;

  async function loadCrosssell() {
    const container = document.querySelector('[data-vt-cart-crosssell]');
    const list = document.querySelector('[data-vt-cart-crosssell-list]');
    if (!container || !list) return;

    let cart;
    try {
      cart = await fetch('/cart.js').then((r) => r.json());
    } catch (e) {
      return;
    }
    if (!cart.items || cart.items.length === 0) {
      container.hidden = true;
      return;
    }

    const cartProductIds = new Set(cart.items.map((i) => i.product_id));
    const baseProductId = cart.items[0].product_id;

    let data;
    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${baseProductId}&limit=6&intent=related`
      );
      data = await res.json();
    } catch (e) {
      container.hidden = true;
      return;
    }

    const suggestions = (data.products || [])
      .filter((p) => !cartProductIds.has(p.id))
      .slice(0, 3);

    if (suggestions.length === 0) {
      container.hidden = true;
      return;
    }

    list.innerHTML = suggestions
      .map((p) => {
        const image = p.featured_image || (p.images && p.images[0]) || '';
        // Antes usaba document.documentElement.lang (sólo "en", sin
        // región) como locale — Intl con "en" a secas formatea EUR con
        // punto decimal, mientras el resto del carrito (line items,
        // vía el filtro nativo `money` de Shopify) usa coma. Pasar
        // `undefined` deja que el navegador use el locale regional real
        // del visitante, igual que hace Shopify con money_format.
        const price = (p.price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'EUR',
        });
        return `
          <a class="vt-cart-crosssell-item" href="${p.url}">
            <img src="${image}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy" width="96" height="96">
            <div class="name">${p.title}</div>
            <div class="price">${price}</div>
          </a>
        `;
      })
      .join('');
    container.hidden = false;
  }

  document.addEventListener('cart:update', loadCrosssell);

  if (document.readyState === 'complete') {
    loadCrosssell();
  } else {
    window.addEventListener('load', loadCrosssell);
  }
})();
